<template>
  <section class="container pmark">
    <div>
      <div>当サイトはSSL により個人情報を暗号化して通信しています。</div>
      <div>
        <iframe class="seal" src="seal.html" frameborder="0"></iframe>
      </div>
      <div><a href="https://privacymark.jp/" target="_blank"><img class="pmark" src="/images/10190226_pmark.png" alt="プライバシーマーク"></a></div>
    </div>
  </section>
</template>

<style scoped lang="scss">
iframe.seal {
  width: 300px;
  height: 88px;
}

section.pmark {
  text-align: right;
}

section.pmark > div {
  display: inline-block;
  max-width: 300px;
  text-align: left;
}

img.pmark {
  width: 75px;
  height: 75px;
}
</style>

<script>
export default {
  name: 'PrivacyMark'
}
</script>
